export default __webpack_public_path__ + "static/media/hibarra.dffc336d.jpg";